import { request } from '../request';

export default {
  getPaymentsCredits: () =>
    request({
      url: '/payments/credits',
      method: 'GET',
    }),
  updatePaymentsEmail: (params) =>
    request({
      url: '/payments/emails',
      method: 'POST',
      data: params,
    }),
  getPurchases: (params) =>
    request({
      url: '/payments/purchases',
      method: 'GET',
      params,
    }),
  pay: (params) =>
    request({
      url: '/paypal/complete',
      method: 'POST',
      data: params,
    }),
  getDenominations: () =>
    request({
      url: '/payments/denominations',
      method: 'GET',
    }),
  getAutomaticPayment: (params) =>
    request({
      url: '/payments/automatic',
      method: 'GET',
      params,
    }),
  saveAutomaticRecharge: (params) =>
    request({
      url: '/payments/automatic',
      method: 'POST',
      data: params,
    }),
  editAutomaticRecharge: (params) =>
    request({
      url: `/payments/automatic/${params.pbxId}`,
      method: 'POST',
      data: params.data,
    }),
  removeAutomaticRecharge: (params) =>
    request({
      url: `/payments/automatic/${params.pbxId}`,
      method: 'DELETE',
    }),
  rechargeCredit: (params) =>
    request({
      url: '/payments/recharge',
      method: 'POST',
      data: params,
    }),
};
